import ConsultantDetail from './ConsultantDetail';

export default ConsultantDetail;
